__webpack_require__.p = "/daily-darshan-slider/";